import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router/* , ActivatedRoute */ } from '@angular/router';

import { TarifConfigurationService } from 'src/app/core/services/tarif-configuration.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-tarif-configuration',
  templateUrl: './tarif-configuration.component.html',
  styleUrls: ['./tarif-configuration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TarifConfigurationComponent implements OnInit {

  tarifConfigurationForm!: FormGroup;
  tarifId: number | null = null;
  estModeEdition = false;
  textBody = 'Configuration Tarifaire';
  chargement = false;

  constructor(
    private fb: FormBuilder,
    public tarifConfigurationService: TarifConfigurationService,
    private messageService: MessageService,
    private toastService: ToastService,
    private router: Router,
    //private route: ActivatedRoute
  ) {
    this.tarifConfigurationForm = this.fb.group({
      id: [null],
      flgTarifParZone: [false, Validators.required],
      montantParKgSup: [null, [Validators.required, Validators.min(0)]],
      montantForfait: [null, [Validators.required, Validators.min(0)]],
      poidsForfaitaireMax: [null, [Validators.required, Validators.min(0)]],
      observations: ['']
    });
  }

  ngOnInit(): void {
    this.chargerConfigurationActive();
  }

  chargerConfigurationActive(): void {
    this.chargement = true;
    this.tarifConfigurationService.obtenirTarifConfiguration().subscribe(
      (donnees) => {
        if (donnees && donnees.id) {
          this.tarifConfigurationForm.patchValue(donnees);
          this.estModeEdition = false;
          this.textBody = 'Voir la Configuration Tarifaire';
        } else {
          this.textBody = 'Créer une Configuration Tarifaire';
        }
        this.chargement = false;
      },
      () => {
        this.chargement = false;
        this.textBody = 'Créer une Configuration Tarifaire';
      }
    );
  }

  onSubmit() {
    if (this.tarifConfigurationForm.invalid) {
      this.tarifConfigurationForm.markAllAsTouched();
      this.toastService.erreur(
        this.messageService.obtenirErreursValidationFormulaire(this.tarifConfigurationForm),
        'Erreur de saisie'
      );
      return;
    }

    this.chargement = true;
    const donneesFormulaire = this.tarifConfigurationForm.value;

    this.tarifConfigurationService.enregistrerTarifConfiguration(donneesFormulaire, !this.estModeEdition).subscribe(
      () => {
        this.chargement = false;
        this.toastService.succes(
          this.estModeEdition ? 'Configuration modifiée avec succès' : 'Configuration créée avec succès'
        );
        this.router.navigate(['tarif/configuration/lister']);
      },
      (erreur) => {
        this.chargement = false;
        this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
      }
    );
  }

  obtenirMessageErreur(nomChamp: string): string {
    const controle = this.tarifConfigurationForm.get(nomChamp);
    if (!controle || !controle.errors || !controle.touched) {
      return '';
    }
    if (controle.errors['required']) {
      return 'Ce champ est obligatoire';
    }
    if (controle.errors['min']) {
      return 'La valeur doit être supérieure ou égale à ' + controle.errors['min'].min;
    }
    return '';
  }

  toggleEditMode() {
    this.estModeEdition = !this.estModeEdition;
  }
}
